import React from 'react'
import { Select } from 'antd'
import { LANGS, LANG_NAMES } from './../../consts'

const { Option, OptGroup } = Select

export function SelectLanguage({ initialData, setData }) {
  function handleChange(idiomasSelected) {
    let data = initialData
    if (idiomasSelected.length > 0) {
      data = data.filter((op) => idiomasSelected.includes(op.idioma))
    }
    setData(data)
  }

  return (
    <Select
      mode="multiple"
      style={{ width: '80%' }}
      placeholder="Language"
      onChange={handleChange}
      optionLabelProp="label"
    >
      <OptGroup label="Language">
        {LANGS.map((lang) => (
          <Option value={lang} label={LANG_NAMES[lang]} key={lang}>
            <div>{LANG_NAMES[lang]}</div>
          </Option>
        ))}
      </OptGroup>
    </Select>
  )
}
